import React from 'react'
import { Alert, Card, Empty, Skeleton } from 'antd'
import Configuration from '../../domain/Configuration'

interface EntityStateProps {
    id?: string
    loading: boolean
    error: string | null
    // The entity is loaded and can be shown
    ready: boolean
    emptyText: string
    children: React.ReactNode
}

// Empty, loading and error states around a looked-up entity
const EntityState: React.FC<EntityStateProps> = ({ id, loading, error, ready, emptyText, children }) => {
    if (ready) return <>{children}</>

    if (loading)
        return (
            <Card>
                <Skeleton active paragraph={{ rows: 4 }} />
            </Card>
        )

    if (error)
        return (
            <Alert
                type="error"
                showIcon
                message="We couldn’t load this"
                description={Configuration.EDIT_COUNTRY() ? `${error} If it was created in another region, switch the region at the top.` : error}
            />
        )

    if (!id)
        return (
            <Card>
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={emptyText} />
            </Card>
        )

    return null
}

export default EntityState
